import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import useEmpresa from "../../../hooks/useEmpresa";
import { cleanNumber } from "../../../utils/NumberUtil";
import { isEmptyValue } from "../../../utils/StringUtil";
import Colors from "../../../themes/Colors";

const BusquedaIngresoForm = (props) => {
  const { formCierreCuentasData, authUserData } = props;

  const empresa = useEmpresa();

  const onStateChange =
    (key, format = null) =>
    (value) => {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        [key]: format ? format(value) : value,
      });
    };

  const buscarIngreso = () => {
    const { numeroIngresoBusqueda, anioBusqueda } = formCierreCuentasData;

    if (isEmptyValue(numeroIngresoBusqueda) || isEmptyValue(anioBusqueda)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: "Favor completar los campos.",
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showDetalleIngreso: false,
            });
          },
        },
        showAlert: true,
      });

      return;
    }

    props.consultarIngreso({
      numeroIngreso: numeroIngresoBusqueda,
      ano: anioBusqueda,
      reclamante: authUserData?.prestador,
      compania: empresa?.CODIGO,
      formCierreCuentasData,
      formHandler: props.formCierreCuentas,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      buscarIngreso();
    }
  };

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"}>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Año"}
            label={"Año"}
            maxLength={4}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formCierreCuentasData?.anioBusqueda}
            onChange={onStateChange("anioBusqueda", cleanNumber)}
            handleKeyPress={handleKeyPress}
          />
        </FormGroup>

        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Número de Ingreso"}
            label={"Número de Ingreso"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={formCierreCuentasData?.numeroIngresoBusqueda}
            onChange={onStateChange("numeroIngresoBusqueda", cleanNumber)}
            handleKeyPress={handleKeyPress}
          />
        </FormGroup>
 
        <FormGroup>
          <CustomButton
            label={"Buscar"}
            onClick={buscarIngreso}
            isLoading={false}
            height={"38px"}
            width={"300px"}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarIngresoLoading: state.ingreso.consultarIngresoLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  consultarIngreso: IngresoActions.consultarIngreso,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaIngresoForm);
